import { useState } from 'react';

export interface ModalConfirmationType {
    open: boolean;
    title?: string;
    description?: string;
}

export interface ModalConfirmationHook {
    modalConfirmationData: ModalConfirmationType;
    toggle: () => void;
    setModalData: (title: string, confirmText: string) => void;
}

const useConfirmationModal = () => {
    const [modalConfirmationData, setModalConfirmationData] = useState<ModalConfirmationType>({
        open: false,
        title: '',
        description: ''
    });

    const toggle = () => {
        setModalConfirmationData({ ...modalConfirmationData, open: !modalConfirmationData.open });
    };

    const setModalData = (title: string, description: string) => {
        setModalConfirmationData({
            open: true,
            title,
            description
        });
    };

    return {
        modalConfirmationData,
        toggle,
        setModalData
    };
};

export default useConfirmationModal;
